/* eslint-disable no-restricted-globals */
import axios from 'axios';
import https from 'https';

const api = axios.create({
  baseURL: `/api`,
  httpsAgent: new https.Agent({
    rejectUnauthorized: true,
  }),
});

export default api;
